'use client';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const ContentWraper = styled.div`
  grid-area: content;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${Spacers.LG}rem;
`;

export const ShiftTitle = styled.h1`
  font-size: ${({ theme }) => theme.typography.heading1.fontSize};
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-weight: ${({ theme }) => theme.typography.heading1.fontWeight};
  line-height: ${({ theme }) => theme.typography.heading1.lineHeight};
`;

export const ShiftDescription = styled.p`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  color: ${({ theme }) => theme.colors.typographyBodyLight};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.lineHeight};
`;

export const CreateShiftFormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.LG}rem;
`;

export const TimeContainer = styled.div`
  display: flex;
  gap: ${Spacers.LG}rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${Spacers.BASE}rem;
  width: 100%;
`;

export const ApprovalList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.LG}rem;
`;

export const ApprovalItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${Spacers.XS}rem;
`;

export const CheckIconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const ApprovalText = styled.p`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  color: ${({ theme }) => theme.colors.typographyBodyLight};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.lineHeight};
  margin: 0;
`;
